function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("path", {
  id: "vertical-align-top_svg__a",
  d: "M13.352 8.146l4.308 4.308a.5.5 0 01-.354.854L14 13.307v11.33c0 .752-.448 1.363-1 1.363s-1-.61-1-1.364V13.307H8.691a.5.5 0 01-.354-.853l4.308-4.308a.5.5 0 01.707 0zM24.184 4c.727 0 1.316.448 1.316 1s-.59 1-1.316 1H1.816C1.089 6 .5 5.552.5 5s.59-1 1.316-1h22.368z"
}));

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("mask", {
  id: "vertical-align-top_svg__b",
  fill: "#fff"
}, React.createElement("use", {
  xlinkHref: "#vertical-align-top_svg__a"
})), React.createElement("use", {
  fill: "#000",
  fillRule: "nonzero",
  xlinkHref: "#vertical-align-top_svg__a"
}), React.createElement("g", {
  fill: "#000",
  mask: "url(#vertical-align-top_svg__b)"
}, React.createElement("path", {
  d: "M-160-36.09h340v100h-340z"
})));

var SvgVerticalAlignTop = function SvgVerticalAlignTop(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 26 30"
  }, props), _ref, _ref2);
};

export default SvgVerticalAlignTop;